  import React, { useEffect, useState } from "react";
  import SchoolModal from "../../components/modals/schoolModal";
  import { useNavigate, useLocation } from "react-router-dom";

  const SchoolPage = ({fetchData}) => {
    const navigate = useNavigate();
    const location = useLocation();

    const editData = location.state?.editData || null;

    // 👉 status = true => create, false => update
    const status = !editData;

    useEffect(() => {
      if (!status && editData) {
        console.log("Edit mode data:", editData);
      } else {
        console.log("Create mode");
      }
    }, [status, editData]);

    const handleClose = () => {
      navigate(-1); // Go back
    };
const handleCloseSubmit = (finalData) => {
  console.log("Form submitted:", finalData);
  fetchData?.();       // Optional reload
  navigate(-1);        // ✅ Go back after submit
};

    return (
      <div style={{ padding: "20px" }}>
        <SchoolModal
          status={status}
          onClose={handleClose}
          onClose1={handleCloseSubmit}
          dataProp={editData}
          navigate={navigate}
        />
      </div>
    );
  };

  export default SchoolPage;
